<template>
    <div id="Dashboard">

        <!-- Human -->
        <div class="mission-section-dashboard">
            <h4 class="welcome-text">
                Human
            </h4>
        </div>
        <div class="dashboard-dashboard">
            <div class="lifelink-card-dashboard card-dashboard devices-dashboard devices-card-dashboard" @click="sideNavClick('Human')" style="text-align: center; background-color: #0147ab; border: 1px solid #0147ab; height: 172px; color: white">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">In Progress</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">03</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span>
                </p>
            </div>
            
            <div class="workflow-card-dashboard card-dashboard devices-dashboard locations-card-dashboard" @click="sideNavClick('Human')" style="text-align: center; background-color: #47d7ac; border: 1px solid #47d7ac; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Completed</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">01</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span> 
                </p>
            </div>

            <div class="lifelink-card-dashboard card-dashboard devices-dashboard devices-card-dashboard" @click="sideNavClick('Human')" style="text-align: center; background-color: #add8e6; border: 1px solid #add8e6; height: 172px;"> 
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Total</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">04</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span>
                </p>
            </div>

            <div class="workflow-card-dashboard card-dashboard devices-dashboard locations-card-dashboard" @click="sideNavClick('Contract Designer')" style="text-align: center; background-color: #f8f9fa; border: 1px solid #adadad; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Workflow Builder</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">03</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span> 
                </p>
            </div>            
        </div>


        <!-- widget test -->
        <div class="dashboard-chart-row">
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Workflows by Activity
                </div>
                <img class="" style="" src="../assets/images/charts/workflowByActivity.png" />
            </div>
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Workflows by Status
                </div>
                <img class="" style="" src="../assets/images/charts/workflowByStatus.png" />
            </div>            
        </div>

        <div class="dashboard-chart-row">
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Workflows by Status
                </div>                
                <img class="" style="" src="../assets/images/charts/byStatus.png" />
            </div>
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Workflows Weekly Trends
                </div>                
                <img class="" style="" src="../assets/images/charts/weeklyTrend.png" />
            </div>            
        </div>
        
        <div class="dashboard-chart-row">
            <div class="dashboard-chart-cell">
                <div class="dashboard-chart-title">
                    Sample by Sector
                </div>                
                <img class="" style="" src="../assets/images/charts/sampleBySector.png" />
            </div>
            <div class="dashboard-chart-cell" style="border: none">
                
            </div>            
        </div>        

        <!-- Bovine -->
        <div class="mission-section-dashboard" style="display: none;">
            <h4 class="welcome-text">
                Bovine
            </h4>
        </div>
        <div class="dashboard-dashboard" style="display: none;">
            <div class="lifelink-card-dashboard card-dashboard devices-dashboard devices-card-dashboard" @click="sideNavClick('Bovine')" style="text-align: center; background-color: #47d7ac; border: 1px solid #47d7ac; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">In Progress</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">68</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span>
                </p>
            </div>
            <div class="workflow-card-dashboard card-dashboard devices-dashboard locations-card-dashboard" @click="sideNavClick('Bovine')" style="text-align: center; background-color: #add8e6; border: 1px solid #add8e6; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Completed</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">00</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span> 
                </p>
            </div>
        </div>        

        <!-- Aquaculture -->
        <div class="mission-section-dashboard" style="display: none;">
            <h4 class="welcome-text">
                Aquaculture x
            </h4>
        </div>
        <div class="dashboard-dashboard" style="display: none;">
            <div class="lifelink-card-dashboard card-dashboard devices-dashboard devices-card-dashboard" @click="sideNavClick('Aquaculture')" style="text-align: center; background-color: #47d7ac; border: 1px solid #47d7ac; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">In Progress</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">57</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span>
                </p>
            </div>
            <div class="workflow-card-dashboard card-dashboard devices-dashboard locations-card-dashboard" @click="sideNavClick('Aquaculture')" style="text-align: center; background-color: #add8e6; border: 1px solid #add8e6; height: 172px;">
                <p class="card-title-dashboard" style="text-align: left; font-size: 16px;">Completed</p>
                <p class="card-title-dashboard" style="text-align: left; font-size: 28px;">00</p>
                <p class="card-title-dashboard" style="text-align: right; font-size: 18px;">
                    <span>View</span>
                    <span>
                        <svg style="margin-top: -3px; margin-left: 5px;" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="22" width="22" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path></svg>
                    </span> 
                </p>
            </div>
        </div>             

    </div>    
</template>

<script>
    export default {
        name: 'dashboard',
        data: function () {
            return {
                test: "test data",
            };
        },
        props: [],
        methods: {
            sideNavClick: function (link) {
                console.log(link);
                this.$parent.sideNavClick(link);
            }
        },
        mounted: function () {    

        }
    }
</script>

<style>
    .dashboard-chart-row {
        display: flex;
        gap: 26px;
        margin-bottom: 30px;
    }

    .dashboard-chart-cell {
        border: 1px solid #c3c3c3;
        border-radius: 2%;
        flex: 1;  
        display: flex;
        justify-content: center; /* horizontal */  
        position: relative;
    }

    .dashboard-chart-title {
        position: absolute;
        top: 10px;
        left: 15px;
        font-size: 16px;;
    }

    .dashboard-chart-cell img {
        max-width: 100%;
        height: auto;
        display: block; /* optional: removes little baseline gap */
    }

    .welcome-text {
      font-size: 28px;
      font-weight: 400 !important
    }

    .dashboard-dashboard {
      display: flex;
      gap: 26px;
      margin-bottom: 26px;
    }

    .card-dashboard {
      flex: 1;
      padding: 20px;
      border-radius: 5px;
      color: #000;
      position: relative;
      height: 155px;;
    }

    .devices-card-dashboard:hover {
      cursor: pointer;
      filter: brightness(0.9) !important;
    }

    .locations-card-dashboard:hover {
      cursor: pointer;
      filter: brightness(0.9) !important;
    }    

    .devices-dashboard {
      background-color: #47d7ac;
    }

    .smart-contracts-dashboard {
      background-color: #0047ab; 
      color: #fff;
    }

    .locations-dashboard {
      background-color: #add8e6;
    }

    .card-title-dashboard {
      /* font-weight: bold; */
      margin-bottom: 10px;
      font-size: 16px;
    }

    .card-number-dashboard {
      font-size: 2em;
      margin-bottom: 20px;
    }

    .card-link-dashboard {
      text-decoration: none;
      color: inherit;
      /* font-weight: bold; */
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 18px;;
    }

    .mission-section-dashboard {
      /* margin-top: 40px; */
    }

    .mission-section-dashboard h2 {
      font-size: 28px;
      margin-bottom: 20px;
    }

    .mission-section-dashboard h4 {
        margin-bottom: 15px;
    }

    .mission-content-dashboard {
      background-color: #edfbf7;
      padding: 30px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .mission-content-dashboard p {
      max-width: 80%;
      font-size: 18px;
      color: #333;
    }

    .lock-icon-dashboard {
      height: 160px;
    }

    @media (max-width: 768px) {
      .dashboard-dashboard {
        flex-direction: column;
      }
      .mission-content-dashboard {
        flex-direction: column;
        text-align: center;
      }
      .mission-content-dashboard p {
        max-width: 100%;
        margin-bottom: 20px;
      }
    }
</style>